import React, { Component } from 'react';
import classes from './TextArea.module.css';

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: this.props.initialRows,
      minRows: this.props.minRows,
      maxRows: this.props.maxRows,
    };
  }

  componentDidMount() {
    this.setState({ rows: this.props.initialRows, minRows: this.props.minRows, maxRows: this.props.maxRows });
    this.resizeTextArea();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.resizeTextArea();
    }
  }

  resizeTextArea = () => {
    const textArea = document.getElementById('textarea');

    const textareaLineHeight = 18;
    const { minRows, maxRows } = this.state;

    const previousRows = textArea.rows;
    textArea.rows = minRows; // reset number of rows in textarea

    // eslint-disable-next-line no-bitwise
    const currentRows = ~~(textArea.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      textArea.rows = currentRows;
    } else if (currentRows > previousRows && currentRows < maxRows) {
      textArea.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      textArea.rows = maxRows;
      textArea.scrollTop = textArea.scrollHeight;
    }

    this.setState({
      rows: currentRows < maxRows ? currentRows : maxRows,
    });
  };

  render = () => {
    const inputClasses = [classes.textarea, classes[this.props.className]];
    if (this.props.selected === true) inputClasses.push(classes.Selected);
    if (this.props.isGift) inputClasses.push(classes.GiftPost);
    return (
      <textarea
        id="textarea"
        rows={this.state.rows}
        value={this.props.value}
        placeholder={this.props.placeholder}
        className={inputClasses.join(' ')}
        onClick={this.props.clicked}
        onChange={(e) => this.props.changed(e)}
        readOnly={this.props.readOnly ? 'readonly' : false}
      />
    );
  };
}

export default TextArea;
